/* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */

@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css");  

:host {
 display: block;
}




/*custom */

a , a:visited {
  color: #b71d1d;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
}

a:hover {
  color: #b71d1d;
  font-size: 16px;
  cursor: pointer;

}
  .accordion-button:not(.collapsed) {
 
    background-color:  rgba(0,0,0,.03);
    color: black;
    box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
}
/* .accordion-button{
 
  background-color:  rgba(0,0,0,.03);
  color: black;
  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);

} */


 .accordion-button:not(.collapsed)::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}
::-webkit-scrollbar {
  width: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #D3D3D3; 
}